const secretSchema = {
	group: "inline",
	inline: true,
	draggable: true,
	attrs: {
		name: { default: "" },
	},
};

export default secretSchema;
